
import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});



export default function ConfirmDeleteDialog(props) {

    const { open, handleCancel, handleDelete, wordToDelete } = props;

    return (

    <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCancel}>
        <DialogTitle id="alert-dialog-slide-title">Are you sure?</DialogTitle>
        <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
                { wordToDelete } -
                Are you sure you want to delete this word? Your colour choices will be lost and you may not be able to provide colours for this word again?
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleCancel} >
                Cancel
            </Button>
            <Button onClick={handleDelete} color="secondary">
            Delete
            </Button>

        </DialogActions>
        </Dialog>

    );
}